import React from 'react';
import { connect } from 'react-redux';
import _, { isEmpty, cloneDeep } from 'lodash';

import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import {
  getRoutes,
  getRoute,
  patchRoute,
  postRoute,
  putStops,
  uploadRouteIntroduction,
  clearRouteError,
} from '../common/actions/routes';
import { getItemsByProviderId } from '../common/actions/items';
import { getDefaultRoute, getDefaultStop, getStopType } from '../common/routes';
import { getUsers } from '../common/actions/users';
import { getMoreToExploreCollection } from '../common/actions/moreToExploreCollection';
import { getFilterStr, getMediaForUIName, openPreviewWindow, getCurrencySymbol } from '../common/global';
import { getCluesByProviderId } from '../common/actions/clues';
import { getProviders } from '../common/actions/providers';
import { getSparks } from '../common/actions/sparks';
import { getChallengesBySparkId } from '../common/actions/challenges';
import { getCluesBySparkId } from '../common/actions/clues';
import RouteList from '../molecules/routes/RouteList';
import RouteDetails from '../molecules/routes/RouteDetails';
import RouteStops from '../molecules/routes/RouteStops';
import ACSaveBar from '../atoms/ACSaveBar';

import styles from './RoutesPage.module.scss';
import { uploadMedia } from '../common/actions/medias';
import { getStoryboardsByProviderId } from 'components/common/actions/storyboards';

class RoutesPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      routes: [],
      route: {},
      stops: [],
      providers: [],
      sparks: [],
      challenges: [],
      items: [],
      clues: [],
      storyBoards : [],
      users: [],
      stop: {},
      routeId: undefined,

      // Search
      searchText: '',
      // updateData is used to store update data field
      updateData: {},

      // upload data
      uploadRouteId: undefined,

      // Confirmation dialog related states
      openDialog: false,
      selection: {},

      // Alert dialog related states
      openAlertDialog: false,
      errors: [],
      counter:0
    };

    // TODO: Replace following bindings with arrow functions.
    this.onChangeSearchText = this.onChangeSearchText.bind(this);
    this.onSelectRoute = this.onSelectRoute.bind(this);
    this.onCreateRoute = this.onCreateRoute.bind(this);
    this.onCopyRoute = this.onCopyRoute.bind(this);
    this.onUpdateRoute = this.onUpdateRoute.bind(this);
    this.onSaveRoute = this.onSaveRoute.bind(this);
    this.onSelectStop = this.onSelectStop.bind(this);
    this.onSaveStop = this.onSaveStop.bind(this);
    this.onSelectProvider = this.onSelectProvider.bind(this);
    this.onSelectItem = this.onSelectItem.bind(this);
    this.onSelectClue = this.onSelectClue.bind(this);
    this.onUpdateStopAction = this.onUpdateStopAction.bind(this);
    this.onSwapStops = this.onSwapStops.bind(this);
    this.onResetSetClue = this.onResetSetClue.bind(this);
    this.getNewStops = this.getNewStops.bind(this);
    this.onUpdateRouteIntroduction = this.onUpdateRouteIntroduction.bind(this);
    this.onUploadIntroduction = this.onUploadIntroduction.bind(this);
    this.onChangeProviderName = this.onChangeProviderName.bind(this);

    this.onClickDialogYes = this.onClickDialogYes.bind(this);
    this.onClickDialogNo = this.onClickDialogNo.bind(this);

    this.onDeleteStop = this.onDeleteStop.bind(this);

    this.setUnsavedDataFlag = this.setUnsavedDataFlag.bind(this);

    this.onClickAlertDialogClose = this.onClickAlertDialogClose.bind(this);
    this.onUpdateStopVariables = this.onUpdateStopVariables.bind(this);
    this.onUpdateStopType = this.onUpdateStopType.bind(this);
    this.onUpdateStoryboard = this.onUpdateStoryboard.bind(this);
    this.onUpdateSelectProvider= this.onUpdateSelectProvider.bind(this);
    this.getRoutes = _.debounce(this.getRoutes, 300);
    this.onClearRouteError = this.onClearRouteError.bind(this);
  }

  componentDidMount() {
    const { id } = this.props;
    this.props.getProvidersFunc();
    this.props.getSparksFunc();
    this.props.getUsersFunc();
    if (id && !isEmpty(id)) {
      this.props.getRouteFunc(id);
    }
  }

  componentDidUpdate(prevProps) {
    if(this.props.payloadTooLargeError && (this.props.payloadTooLargeError !== prevProps.payloadTooLargeError)  && !this.state.openAlertDialog) {
      this.setState({
            openAlertDialog: true,
            errors: ['The product you are trying to assign is too large. For assistance contact the Technology team.'],
          });
    }
  }

  componentWillReceiveProps(props) {
    if (props.refreshRoute && this.props.refreshRoute !== props.refreshRoute) {
      let route = this.state.route;
      if (!isEmpty(route)) this.onSelectRoute(route.id);
    }

    if (props.routes && this.props.routes !== props.routes && isEmpty(this.state.updateData)) {
      this.setState({
        routes: props.routes,
        updateData: {},
      });
    }

    if (props.providers && this.state.providers !== props.providers) {
      this.setState({
        providers: props.providers,
      });
    }

    if (props.sparks && this.state.sparks !== props.sparks) {
      this.setState({
        sparks: props.sparks,
      });
    }

    if (props.challenges && this.state.challenges !== props.challenges) {
      this.setState({
        challenges: props.challenges,
      });
    }

    if (props.clues) {
      this.setState({
        clues: props.clues,
      });
    } else {
      this.setState({
        clues: [],
      });
    }

    if (props.storyBoards) {
      this.setState({
        storyBoards: props.storyBoards,
      });
    } else {
      this.setState({
        storyBoards: [],
      });
    }

    if (props.items) {
      this.setState({
        items: props.items,
      });
    } else {
      this.setState({
        items: [],
      });
    }

    if (props.users && props.users !== this.props.users) {
      this.setState({
        users: props.users,
      });
    }

    if (
      props.moreToExploreCollection &&
      props.moreToExploreCollection !== this.props.moreToExploreCollection
    ) {
      this.setState({
        moreToExploreCollection: props.moreToExploreCollection,
      });
    }

    // This check has been applied because the stops get
    // reset every time when the provider is changed from SetStop form.
    if (props.route && props.route !== this.props.route) {
      if (props.route) {
        console.log('route', props.route);
        this.setState({
          route: props.route,
        });
      }

      if (props.route.stops) {
        this.setState({
          stops: props.route.stops,
        });
      }
    }



    // Implement a better way if possible
    // This has been done to update internal state of routes when the new one has just been added.
    if (props.routeNewId && props.routeNewId !== this.props.routeNewId) {
      let routes = [...this.state.routes];
      // Update Local routes
      if (routes) {
        let updatedRoutes = routes.map((r) => {
          let route = r;
          if (route.id) {
            if (route.id === '') route.id = props.routeNewId;
          } else {
            route.id = props.routeNewId;
          }
          return route;
        });
        this.setState({
          routes: updatedRoutes,
        });
      }
    }
    if (props.filter && props.filter !== this.props.filter) {
      let filterStr = getFilterStr(props.filter);
      //addd to hinde archived routes, remove when filter for status is added to ui
      filterStr += '&status=active&status=inactive';
      console.log('main page load :: ', filterStr);
      this.props.getRoutesFunc(filterStr);

      // Reset the some internal states becauase:
      // 1. Filter misleads the selection
      // 2. The routes don't get updated if updateData has not been cleared
      this.setState({
        routes: [],
        route: {},
        stops: [],
        updateData: {},
      });
    }

    if (
      props.uploadData &&
      props.uploadData.Location !== this.state.route?.introduction?.medias?.[0]?.url
    ) {
      // Internal update
      let routes = [...this.state.routes];
      let route = cloneDeep(this.state.route);
      let routeFlag = false;

      for (let r of routes) {
        if (r.id !== route.id) continue;
        // override medias
        let introduction = r.introduction || {};
        introduction.medias = [];
        introduction.medias.push({ url: props.uploadData.Location });

        r.introduction = introduction;
        route = r;
        routeFlag=true;
      }
      if(!routeFlag){
        // This route Flag is used to update a route when not found in the routeList Array
        let introduction = route.introduction || {};
        introduction.medias = [];
        introduction.medias.push({ url: props.uploadData.Location });

        route.introduction = introduction;
        // route = route;
      }
      this.setState({
        routes,
        route,
        updateData: {
          introduction: route.introduction,
        },
      });
    }
  }

  onClearRouteError() {
    this.props.clearRouteErrorFunc();
  }

  onSelectRoute(routeId) {
    if (!isEmpty(this.state.updateData)) {
      this.setState({
        openDialog: true,
        selection: {
          routeId,
        },
      });
      return;
    }
    console.log('onSelectRoute called');
    const routes = this.state.routes;
    const rs = routes.filter((r) => r.id === routeId);
    if (rs && rs.length > 0) {
      const r = rs[0];
      console.log('setting route onSelectRoute', r);
      this.setState({
        route: r,
        stops: [],
        // Reset updateData
        updateData: {},
      });

      if (routeId) {
        this.props.getRouteFunc(routeId);
      }
      // this.props.getProvidersFunc();
    }
  }

  onClickDialogYes() {
    this.setState(
      {
        openDialog: false,
        // Reset updateData
        updateData: {},
      },
      // Callback function has been used to make the selection,
      // if the user decides to leave the changes.
      () => {
        if (!isEmpty(this.state.selection))
          this.onSelectRoute(this.state.selection.routeId);
      }
    );
  }

  onClickDialogNo() {
    this.setState({
      openDialog: false,
    });
  }

  onInputChangeMoreToExplore = (query) => {
    if (query) this.props.getMoreToExploreCollectionFunc(`&keyword=${query}`);
  };

  onChangeProviderName(value) {
    const filterStr = '&query=' + encodeURIComponent(value);

    if (value) this.props.getProvidersFunc(filterStr);
    else this.props.getProvidersFunc();
  }

  setUnsavedDataFlag(unsavedData) {
    if (!isEmpty(unsavedData)) this.props.setUnsavedDataFlagFunc(true);
  }

  resetUnSavedDataFlag() {
    this.props.setUnsavedDataFlagFunc(false);
  }

  getRoutes = (searchText) => {
    let filterStr = getFilterStr(this.props.filter);
    filterStr += '&status=active&status=inactive';
    filterStr += '&query=' + encodeURIComponent(searchText);
    this.props.getRoutesFunc(filterStr);
  };

  onChangeSearchText(event) {
    const searchText = event.target.value;
    this.getRoutes(searchText);
    this.setState({
      searchText,
    });
  }

  onCreateRoute() {
    // Internal update
    let rs = [...this.state.routes];
    let updateData = {};

    // This indicates there is already an unsaved route
    let found = rs.find((r) => {
      return !r.id || r.id === '';
    });
    if (found) return;

    let newRoute = getDefaultRoute();
    // newRoute.name = 'New Name';

    // updateData.name = 'New Name';
    updateData.status = 'active';

    rs.push(newRoute);

    this.setState({
      routes: rs,
      stops: [],
      route: newRoute,
      updateData: updateData,
    });
  }

  onCopyRoute(route, stops) {
    // Internal update
    let rs = [];
    if (this.state.routes.length > 0) rs = [...this.state.routes];

    // This indicates there is already an unsaved routes
    let found = rs.find((r) => {
      return !r.id || r.id === '';
    });
    if (found) return;

    let clonedRoute = {
      ...route,
    };

    let clonedStops = [];

    if (this.state.stops.length > 0) {
      clonedStops = [...stops];
    }
    clonedRoute.name = `Copy of ${route.name}`;
    clonedRoute.stops = this.getClonedStops(clonedStops);
    delete clonedRoute.id;
    // Component links are not cloned. `components` is mirrored from content-api's
    // `component_experience_routes` table, so a copy carrying it would be offered in the
    // planner for a component that has no record of it. Link the copy from the component's
    // own page in the Hub. `componentId`/`component` are the retired single connection,
    // dropped here too so a clone of an old dev route does not carry it forward.
    delete clonedRoute.components;
    delete clonedRoute.componentId;
    delete clonedRoute.component;
    rs.push(clonedRoute);
    this.setState({
      routes: rs,
      route: clonedRoute,
      stops: clonedStops,
      updateData: clonedRoute,
    });
  }

  // FIXME: Use clone method from lodash. More testing required around the area as it's bit fiddly.
  // This is a different array of objects than the aggregate ones.
  getClonedStops(stops) {
    const ss = [];

    stops.forEach((s) => {
      let tempStop = {};
      tempStop.sparkId = s.sparkId;
      tempStop.challengeId = s.challengeId;
      tempStop.providerId = s.providerId;
      tempStop.clueId = s.clueId;
      tempStop.itemId = s.itemId;
      tempStop.action = s.action;
      tempStop.variables = s.variables;
      tempStop.type = s.type;
      ss.push(tempStop);
    });

    return ss;
  }


  onSaveRoute() {
    // External update
    let ud = cloneDeep(this.state.updateData);

    if (isEmpty(ud) || !this.state.route) return;

    if (this.state.route.id) ud.id = this.state.route.id;
      if (ud.id) {
        this.props.patchRouteFunc(ud);
      } else {
        if (!ud.name) {
          this.setState({
            openAlertDialog: true,
            errors: ['Please enter a route name to save.'],
          });
          return;
        }
        this.props.postRouteFunc(ud);
        this.setState({
          route: {},
        });
      }

      this.setState({
        updateData: {},
      });
    this.resetUnSavedDataFlag();
  }

  onUpdateRoute(key, value) {
    // Internal Update
    let rs = [...this.state.routes];
    let r = cloneDeep(this.state.route);
    let ud = cloneDeep(this.state.updateData);

    r[key] = value;
    ud[key] = value;

    // A route connects to a product. Assigning a component here is retired - a component now
    // names its routes from the Hub, mirrored onto the route as `components`, which is
    // independent of this connection and must never appear in a save from this screen. The
    // retired `componentId`/`component` keys are still cleared on a product save, so a route
    // saved through the picker sheds the old single connection if it had one.
    const setConnection = (connection) => {
      Object.entries(connection).forEach(([k, v]) => {
        r[k] = v;
        ud[k] = v;
      });
    };

    if (key === 'product') {
      setConnection({
        connectionType: 'product',
        productId: value?.id ?? null,
        componentId: null,
        component: null,
      });
    }

    rs.forEach((newR) => {
      if (newR.id === r.id) {
        newR[key] = value;
        if (key === 'product') {
          newR.connectionType = r.connectionType;
          newR.productId = r.productId;
          newR.product = r.product;
          newR.componentId = r.componentId;
          newR.component = r.component;
        }
      }
    });

    this.setState({
      routes: rs,
      route: r,
      updateData: ud,
    });
  }

  onUpdateRouteIntroduction(key, value) {
    // Internal Update
    let rs = [...this.state.routes];
    let r = cloneDeep(this.state.route);
    let ud = cloneDeep(this.state.updateData);
    if (!r.introduction) r.introduction = {};
    if (!ud.introduction) ud.introduction = {};

    ud.introduction = r.introduction;
    r.introduction[key] = value;
    ud.introduction[key] = value;

    rs.forEach((newR) => {
      if (newR.id === r.id) {
        if (!newR.introduction) newR.introduction = {};
        newR.introduction[key] = value;
      }
    });
    this.setState({
      routes: rs,
      route: r,
      updateData: ud,
    });
  }

  onUpdateSelectProvider(provider){
    const stop = this.state.stop;
    stop.provider = provider;
    stop.item = {};
    stop.clue = {};
    stop.storyboard={};
    this.setState({
      stop: stop,
    });

    // External update
    if(provider){
      this.props.getItemsByProviderIdFunc(provider.id);
      this.props.getCluesByProviderIdFunc(provider.id);
      this.props.getStoryboards(provider.id);
    }

  }

  onSelectProvider(provider,oldProviderId) {
    const { counter }=this.state;
    
    // Internal update
    if(provider.id && provider.id!==oldProviderId && counter===0){
      this.onUpdateSelectProvider(provider);
      this.setState({
        counter:this.state.counter+1
      })
    }
    if(counter!==0){
      this.onUpdateSelectProvider(provider);
    }
  }

  onSelectItem(item) {
    // Internal update
    const stop = this.state.stop;
    stop.item = item;
    this.setState({
      stop: stop,
    });
  }

  onSelectStopType(type) {
    // Internal update
    const stop = this.state.stop;
    stop.type = type;
    this.setState({
      stop: stop,
    });
  }

  onSelectClue(clue) {
    // Internal update
    const stop = this.state.stop;
    stop.clue = clue;
    this.setState({
      stop: stop,
    });
  }

  onSelectSpark = (spark) => {
    const stop = this.state.stop;
    stop.spark = spark;
    stop.challenge = '';
    stop.clue = '';
    this.setState({ stop });

    const { id = '' } = spark;
    const { getChallengesBySparkIdFunc, getCluesBySparkIdFunc } = this.props;
    getChallengesBySparkIdFunc(id);
    getCluesBySparkIdFunc(id);
  };

  onSelectSparkChallenge = (challenge) => {
    const stop = this.state.stop;
    stop.challenge = challenge;
    this.setState({ stop });
  };

  onSelectSparkClue = (clue) => {
    const stop = this.state.stop;
    stop.clue = clue;
    this.setState({ stop });
  };

  onUpdateStopAction(value) {
    // Internal update
    const stop = this.state.stop;
    stop.action = value;
    this.setState({
      stop: stop,
    });
  }

  onUpdateStopVariables(variables) {
    // Internal update
    let { stop } = this.state;
    stop.variables = variables;
    this.setState({
      stop: stop,
    });
  }

  // FIXME: Create Generic Method to update stop
  onUpdateStopType(type) {
    // Internal update
    let { stop } = this.state;
    stop.type = type;

    this.setState({
      stop: stop,
    });
  }

  onUpdateStoryboard(storyboard) {
    // Internal update
    let { stop } = this.state;
    stop.storyboard = storyboard;

    this.setState({
      stop: stop,
    });
  }

  onSelectStop(stop) {
    // Internal update
    this.setState({
      stop,
    });

    // External update
    if (stop.provider) {
      if (stop.provider.id !== undefined) {
        this.props.getItemsByProviderIdFunc(stop.provider.id);
        this.props.getCluesByProviderIdFunc(stop.provider.id);
         this.props.getStoryboards(stop.provider.id);
      } else {
        // Force clearing items and clues from redux store objects by searching empty string.
        // Otherwise, redux keeps it in memory and this comes back upon next call.
        this.props.getItemsByProviderIdFunc('');
        this.props.getCluesByProviderIdFunc('');
        // this.props.getStoryboardsByProviderId('');
      }
    }
  }

  hasStopErrors(stop) {
    const { type = '' } = stop;
    let isError = true;
    if (stop) {
      isError = false;
      let errors = [];

      if (type === getStopType().SPARK_STOP) {
        const { spark, challenge } = stop;
        if (isEmpty(spark)) {
          isError = true;
          errors.push('Please select a connection spark');
        }
        if (isEmpty(challenge)) {
          isError = true;
          errors.push('Please select a challenge');
        }
      } else {
        if (stop.provider) {
          if (!stop.provider.id) {
            isError = true;
            errors.push('Please select a provider');
          }
          const  providers  = this.props.providers;
          const seleectedProviderData =providers.find((provider)=>provider.id === stop.provider.id);
          const storyboardEnabled = seleectedProviderData?.enablingStoryboard || false;
          if(storyboardEnabled && isEmpty(stop.storyboard)){
            isError = true;
            errors.push('Please select a Storyboard');
          }
        }
        if (type !== getStopType().INSTA_STOP && isEmpty(stop.item)) {
          isError = true;
          errors.push('Please select an item');
        }
        if (stop.clue) {
        if (!stop.clue.id && stop.type !== 'payment-only') {
            isError = true;
            errors.push('Please select a clue');
          }
        }
      }
      if (!stop.type) {
        isError = true;
        errors.push('Please select a stop type');
      }

      this.setState({
        errors,
      });
    }
    return isError;
  }

  onSaveStop() {
    const stop = this.state.stop;
    if (
      stop.type !== 'payment-only' &&
      stop.clue &&
      stop.clue.id &&
      stop.clue.id === 'payment-only-placeholder-clue'
    ) {
      stop.clue = {};
    }
    if (this.hasStopErrors(stop)) {
      this.setState({
        openAlertDialog: true,
      });
      return;
    }

    // Internal Update
    const route = this.state.route;
    let stops = [...this.state.stops];
    if (isEmpty(stops)) stops = [];
    // Zero is default value, hence false
    if (stop.index === null || stop.index === undefined) {
      stops.push(stop);
    } else {
      stops[stop.index] = stop;
    }

    this.setState({
      stops: stops,
      stop: getDefaultStop(),
    });

    const newStops = this.getNewStops(stops);

    // External update
    this.props.putStopsFunc(route.id, newStops);

    return true;
  }

  onDeleteStop(index) {
    // Internal Update
    const route = this.state.route;
    let stops = [...this.state.stops];
    if (isEmpty(stops)) stops = [];
    // Zero is default value, hence false
    if (index >= 0) {
      stops.splice(index, 1);
    }

    this.setState({
      stops: stops,
      stop: getDefaultStop(),
    });

    const newStops = this.getNewStops(stops);

    // External update
    this.props.putStopsFunc(route.id, newStops);
  }

  onSwapStops(stops) {
    // Internal update
    this.setState({
      stops: stops,
    });

    // External update
    const route = this.state.route;
    const newStops = this.getNewStops(stops);
    this.props.putStopsFunc(route.id, newStops);
  }

  getNewStops(stops) {
    const newStops = [];
    stops.forEach((stop) => {
      let newStop = {};

      if (stop.provider) newStop.providerId = stop.provider.id;
      if (stop.clue) newStop.clueId = stop.clue.id;
      if (stop.item) newStop.itemId = stop.item.id;
      if (stop.spark) newStop.sparkId = stop.spark.id;
      if(stop.storyboard) {
        newStop.storyboard = {value:stop.storyboard.value,label:stop.storyboard.label};
        newStop.storyboardId = stop.storyboard.value;
      }
      if (stop.challenge) newStop.challengeId = stop.challenge.id;
      newStop.action = stop.action;
      newStop.variables = stop.variables;
      newStop.type = stop.type;
      newStops.push(newStop);
    });

    return newStops;
  }

  onResetSetClue() {
    const stop = this.state.stop;
    if (!isEmpty(stop)) {
      stop.provider = {};
      stop.item = {};
      stop.clue = {};
    }

    this.setState({
      stop: stop,
      items: [],
      clues: [],
    });
  }

  onClickAlertDialogClose() {
    this.setState({
      openAlertDialog: false,
    });
    if(this.props.payloadTooLargeError) {
      this.onClearRouteError();
    }
  }

  onUploadIntroduction(id, fileList) {
    this.setState({
      uploadRouteId: id,
    });


    this.props.onUploadIntroductionFunc(fileList);
  }

  renderRouteList(routes, route) {
    return (
      <div className={styles.left} key="routeList">
        <RouteList
          searchText={this.state.searchText}
          routes={routes}
          route={route}
          onChangeSearchTextFunc={this.onChangeSearchText}
          onCreateRouteFunc={this.onCreateRoute}
          onSelectRouteFunc={this.onSelectRoute}
          getChallengesBySparkIdFunc={this.props.getChallengesBySparkIdFunc}
          getCluesBySparkIdFunc={this.props.getCluesBySparkIdFunc}
        />
      </div>
    );
  }

  renderRouteDetails(route, stops, users, moreToExploreCollection) {
    const { uploadMediaFunc } = this.props;
    return (
      <div
        className={styles.center}
        onBlur={() => this.setUnsavedDataFlag(this.state.updateData)}
        key="routeDetailsKey"
      >
        <RouteDetails
          route={route}
          stops={stops}
          users={users}
          moreToExploreCollection={moreToExploreCollection}
          providersWhens={route.providersWhens}
          itemsDietaries={route.itemsDietaries}
          onUpdateRouteFunc={this.onUpdateRoute}
          onUpdateRouteIntroductionFunc={this.onUpdateRouteIntroduction}
          onCopyRouteFunc={this.onCopyRoute}
          onUploadIntroductionFunc={this.onUploadIntroduction}
          onInputChangeMoreToExploreFunc={this.onInputChangeMoreToExplore}
          variables={route.variables}
          uploadMediaFunc={uploadMediaFunc}
        />
      </div>
    );
  }

  renderStops(route, stops) {
    const { config } = this.props;
    const { googleMapURL = '' } = config;

    let currencySymbol = '$';
    if (!(route && route.id !== '')) return;

    const newStops = cloneDeep(stops);

    let routePrice = 0;
    if (route.price) routePrice = route.price.price;

    const product = route.product;
    if (product && product.productCities?.length > 0) {
      const { country } = product.productCities[0];
      currencySymbol = getCurrencySymbol(country);
    }

    function onClickPreview () {
      openPreviewWindow({ routeId : route.id})
    }

    return (
      <div className={styles.right} key="routeStopsKey">
        <RouteStops
          stops={newStops}
          routePrice={routePrice}
          providers={this.state.providers}
          sparks={this.state.sparks}
          items={this.state.items}
          challenges={this.state.challenges}
          clues={this.state.clues}
          storyBoards={this.state.storyBoards}
          stop={this.state.stop}
          currencySymbol={currencySymbol}
          onSwapStopsFunc={this.onSwapStops}
          onSelectStopFunc={this.onSelectStop}
          onSelectProviderFunc={this.onSelectProvider}
          onSelectItemFunc={this.onSelectItem}
          onSelectClueFunc={this.onSelectClue}
          onSaveStopFunc={this.onSaveStop}
          onDeleteStopFunc={this.onDeleteStop}
          onUpdateStoryBoardFunc={this.onUpdateStoryboard}
          onUpdateStopActionFunc={this.onUpdateStopAction}
          onUpdateStopVariablesFunc={this.onUpdateStopVariables}
          onUpdateStopTypeFunc={this.onUpdateStopType}
          onClickPreview={onClickPreview}
          onChangeProviderNameFunc={this.onChangeProviderName}
          googleMapURL={googleMapURL}
          onSelectStopTypeFunc={this.onSelectStopType}
          getChallengesBySparkIdFunc={this.props.getChallengesBySparkIdFunc}
          getCluesBySparkIdFunc={this.props.getCluesBySparkIdFunc}
          onSelectSparkFunc={this.onSelectSpark}
          onSelectSparkChallengeFunc={this.onSelectSparkChallenge}
          onSelectSparkClueFunc={this.onSelectSparkClue}
          getSparksFunc={this.props.getSparksFunc}
        />
      </div>
    );
  }

  renderAlertDialog(errors) {
    return (
      <div>
        <Dialog open={this.state.openAlertDialog} aria-labelledby="draggable-dialog-title">
          <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
            {
              this.props.payloadTooLargeError ? 'Failed to Save' :
            `Alert`
            }
          </DialogTitle>
          <DialogContent>
            {errors.map((e) => {
              return <DialogContentText>{e}</DialogContentText>;
            })}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.onClickAlertDialogClose} color="primary">
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  renderConfirmDialog() {
    return (
      <div>
        <Dialog open={this.state.openDialog} aria-labelledby="draggable-dialog-title">
          <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
            Confirm
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              The data has not been saved yet. Are you sure to leave?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.onClickDialogYes} color="primary">
              Yes
            </Button>
            <Button onClick={this.onClickDialogNo} color="primary">
              No
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  render() {
    // TODO: Use destructuring here after new development roll out
    let routes = [...this.state.routes];
    let route = cloneDeep(this.state.route);
    let stops = this.state.stops;
    let users = this.state.users;
    let moreToExploreCollection = this.state.moreToExploreCollection;

    let isEnabled = !isEmpty(this.state.updateData);
    let components = [];

    components.push(this.renderRouteList(routes, route));

    if (!isEmpty(this.state.route)) {
      components.push(
        this.renderRouteDetails(route, stops, users, moreToExploreCollection)
      );
      components.push(this.renderStops(route, stops));
    }

    return (
      <div className={styles.root}>
        {components}
        <ACSaveBar isEnabled={isEnabled} onSaveFunc={this.onSaveRoute} />
        {this.renderConfirmDialog()}
        {this.renderAlertDialog(this.state.errors)}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getRoutesFunc: (filterParams) => dispatch(getRoutes(filterParams)),
    getProvidersFunc: (filterParams) => dispatch(getProviders(filterParams)),
    getSparksFunc: (filterParams) => dispatch(getSparks(filterParams)),
    getRouteFunc: (routeId) => dispatch(getRoute(routeId)),
    getItemsByProviderIdFunc: (providerId) => dispatch(getItemsByProviderId(providerId, true)),
    getCluesByProviderIdFunc: (providerId) => dispatch(getCluesByProviderId(providerId)),
    getUsersFunc: () => dispatch(getUsers()),
    getMoreToExploreCollectionFunc: (query) => dispatch(getMoreToExploreCollection(query)),
    getChallengesBySparkIdFunc: (sparkId) => dispatch(getChallengesBySparkId(sparkId)),
    getCluesBySparkIdFunc: (sparkId) => dispatch(getCluesBySparkId(sparkId)),
    getStoryboards :(providerId) => dispatch(getStoryboardsByProviderId(providerId)),
    patchRouteFunc: (route) => dispatch(patchRoute(route)),
    clearRouteErrorFunc: () => dispatch(clearRouteError()),
    putStopsFunc: (routeId, stops) => dispatch(putStops(routeId, stops)),

    postRouteFunc: (route) => dispatch(postRoute(route)),

    onUploadIntroductionFunc: (fileList) => dispatch(uploadRouteIntroduction(fileList)),
    uploadMediaFunc: (mediaFor, mediaType, file) =>
      dispatch(uploadMedia(mediaFor, mediaType, file)),
  };
};

const mapStateToProps = (state) => {

  const stateRoutes = state.routes;
  const stateProviders = state.providers;
  const stateSparks = state.sparks;
  const stateChallenges = state.challenges;
  const stateItems = state.items;
  const stateClues = state.clues;
  const stateUsers = state.users;
  const stateStoryBoards = state.storyboards;
  const stateMoreToExploreCollection = state.moreToExploreCollection;
  const stateMedias = state.medias || {};
  const { media = {} } = stateMedias;
  const { ui = '' } = media;
  const routeMedia = ui === getMediaForUIName().route ? media : {};

  let newProps = {};
  if (media) {
    newProps.media = routeMedia;
  }

  if (stateRoutes) {
    if (stateRoutes.error) {
      if(stateRoutes.error.httpStatusCode === 413) {
        newProps.payloadTooLargeError = true;
      }
      console.error(stateRoutes.error.message);
    }
    if (stateRoutes.route) {
      newProps.refreshRoute = stateRoutes.refreshRoute;
      if (stateRoutes.route.data) {
        newProps.route = stateRoutes.route.data;
      }
      if (stateRoutes.route.uploadData) {
        newProps.uploadData = stateRoutes.route.uploadData;
        console.log('File has been uploaded to:', newProps.uploadData.Location);
      }
    }
    if (stateRoutes.routes) {
      newProps.routes = stateRoutes.routes.data;
    }
    if (stateRoutes.newId) {
      newProps.routeNewId = stateRoutes.newId.data;
    }
  }

  if (stateProviders) {
    if (stateProviders.error) {
      console.error(stateProviders.error.message);
    }
    if (stateProviders.providers) {
      newProps.providers = stateProviders.providers.data;
    }
  }

  if (stateSparks) {
    if (stateSparks.error) {
      console.error(stateSparks.error.message);
    }
    if (stateSparks.sparks) {
      newProps.sparks = stateSparks.sparks;
    }
  }

  if (stateChallenges) {
    if (stateChallenges.error) {
      console.error(stateChallenges.error.message);
    }
    if (stateChallenges.challenges) {
      newProps.challenges = stateChallenges.challenges;
    }
  }

  if (stateItems) {
    if (stateItems.error) {
      console.error(stateItems.error.message);
    }
    if (stateItems.items) {
      newProps.items = stateItems.items.data;
    }
  }

  if (stateStoryBoards){
    if (stateStoryBoards?.storyboards?.error) {
      console.error(stateStoryBoards.storyboards.error.message);
    }

    if (stateStoryBoards?.storyboards?.data && stateStoryBoards?.storyboards?.data.length >0) {
      newProps.storyBoards = stateStoryBoards.storyboards.data;
    }else{
      newProps.storyBoards = []
    }
  }

  if (stateClues) {
    if (stateClues.error) {
      console.error('stateClues Error : ' + stateClues.error.message);
    }
    if (stateClues.clues) {
      // TODO: Routes and Virtuals return clues in different formats (one is { data : { data : []  }} the other is { data : [] })
      if (stateClues.clues.data && stateClues.clues.data.length) {
        newProps.clues = stateClues.clues.data;
      } else if (stateClues.clues.length) {
        newProps.clues = stateClues.clues;
      } else {
        newProps.clues = [];
      }
    }
  }

  if (stateUsers) {
    if (stateUsers.error) {
      console.error(stateUsers.error.message);
    }
    if (stateUsers.users) {
      newProps.users = stateUsers.users;
    }
  }

  if (stateMoreToExploreCollection) {
    if (stateMoreToExploreCollection.error) {
      console.error(stateMoreToExploreCollection.error.message);
    }
    if (stateMoreToExploreCollection.moreToExploreCollection) {
      newProps.moreToExploreCollection = stateMoreToExploreCollection.moreToExploreCollection;
    }
  }

  if (stateMoreToExploreCollection) {
    if (stateMoreToExploreCollection.error) {
      console.error(stateMoreToExploreCollection.error.message);
    }
    if (stateMoreToExploreCollection.moreToExploreCollection) {
      newProps.moreToExploreCollection = stateMoreToExploreCollection.moreToExploreCollection;
    }
  }
  return newProps;
};

export default connect(mapStateToProps, mapDispatchToProps)(RoutesPage);
